__webpack_require__.p = "https://us-west-2.alpha.categorymanagement.wwgs.amazon.dev/";